<template>
  <div>
    <EventForm
      title="Attend this event"
      :subtitle="subtitle"
      submit-text="Attend event"
      :no-inputs="eventsEmailExists"
      :on-apply-now="toggleApplyNowModal"
      :on-submit="onSubmit"
      :already-joined-error="alreadyJoinedError"
    />
    <Modals
      :toggle-apply-now="toggleApplyNowModal"
      :toggle-success="toggleSuccessModal"
      :show-apply-now="showApplyNowModal"
      :show-success="showSuccessModal"
    />
  </div>
</template>

<script>
import EventForm from '../EventForm/EventForm.vue';
import Modals from '../Modals/Modals.vue';

export default {
  components: {
    EventForm,
    Modals,
  },
  props: {
    eventId: {
      type: Number,
      required: true,
    },
    eventPrivate: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['email-joined'],
  data() {
    return {
      showApplyNowModal: false,
      showSuccessModal: false,
      alreadyJoinedError: false,
      eventsEmailExists: true,
    };
  },
  computed: {
    subtitle() {
      return this.eventPrivate
        ? 'This is an exclusive event for Proxify members.'
        : '';
    },
  },
  mounted() {
    this.eventsEmailExists =
      this.$localStorage.getItem('events_email') !== null;
  },
  methods: {
    toggleApplyNowModal() {
      this.showApplyNowModal = !this.showApplyNowModal;
    },
    toggleSuccessModal() {
      this.showSuccessModal = !this.showSuccessModal;

      if (!this.showSuccessModal) {
        this.$emit('email-joined');
      }
    },
    async onSubmit(email) {
      try {
        await this.$cmsApi.post(`/events/${this.eventId}/register`, { email });

        this.toggleSuccessModal();

        this.$localStorage.setItem('events_email', email);
        this.eventsEmailExists = true;

        this.$analytics.track('CTA Clicked', {
          cta_name: 'Confirm Attendance',
          page_name: 'Event_page',
        });
      } catch (error) {
        if (error.response.status === 401) {
          this.toggleApplyNowModal();
        } else if (error.response.status === 409) {
          this.alreadyJoinedError = true;

          setTimeout(() => {
            this.setEmailEligible(email);

            this.$emit('email-joined');
          }, 2000);
        }
      }
    },
    setEmailEligible(email) {
      this.$localStorage.setItem('events_email', email);
      this.eventsEmailExists = true;
    },
  },
};
</script>
